export default {
  powertrackLogo: require("../assets/images/pv2-images/powertrack.png"),
  avatar: require("../assets/images/pv2-images/avatar.jpg"),
  timeclock: require("../assets/images/pv2-images/clock.svg").default,
  schedule: require("../assets/images/pv2-images/schedule.svg").default,
  catalog: require("../assets/images/pv2-images/catalog.svg").default,
  deliveryOrder: require("../assets/images/pv2-images/delivery-order.svg")
    .default,
  leaveFilling: require("../assets/images/pv2-images/leave-filing.svg").default,
  claims: require("../assets/images/pv2-images/claims.svg").default,
  eDocs: require("../assets/images/pv2-images/edocs.svg").default,
  communications: require("../assets/images/pv2-images/communications.svg")
    .default,
  rewards: require("../assets/images/pv2-images/rewards.svg").default,
  ellipsis: require("../assets/images/pv2-images/ellipsis.png"),
  rocket: require("../assets/images/pv2-images/rocket.png"),
  coffeeBreak: require("../assets/images/pv2-images/coffee-break.png"),
  coffeeBreakRed: require("../assets/images/pv2-images/coffee-break-red.png"),
  leave: require("../assets/images/pv2-images/leave.png"),
};
